import { render } from "./VehicleManufacturerView.vue?vue&type=template&id=5ec7a252&scoped=true&ts=true"
import script from "./VehicleManufacturerView.vue?vue&type=script&lang=ts"
export * from "./VehicleManufacturerView.vue?vue&type=script&lang=ts"

import "./VehicleManufacturerView.vue?vue&type=style&index=0&id=5ec7a252&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec7a252"]])

export default __exports__